
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Link, Typography, Container, CssBaseline, IconButton, AppBar, Toolbar, Box, Button, Menu, MenuItem } from '@mui/material';
import { WhatsApp as WhatsAppIcon, Menu as MenuIcon} from '@mui/icons-material';
import { Outlet, useNavigate } from "react-router-dom";

import React from 'react';

function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://mui.com/">
                Neptune Technology
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const defaultTheme = createTheme({
        palette: {
            background: {
                default: "#bbdefb"
            }
        }
});

const pages = [
    { name: 'About', link: '/about-us' },
    { name: 'Our Services', link: '/our-service' },
    { name: 'Spectifications', link: '/tech-specs' }
];

function DefaultLayout() {
    const navigate = useNavigate();

    const onWhatsApp = () => {
        window.open('https://wa.me/6597629183', '_blank');
    };

    const handleNavigation = (link) => {
        navigate(link);
        handleCloseNavMenu()
    };

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <CssBaseline />
            <AppBar position="relative">
                <Toolbar>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page.name} onClick={() => handleNavigation(page.link)}>
                                    <Typography textAlign="center">{page.name}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} >
                        <Button sx={{ color: 'white', display: 'block' }} onClick={() => handleNavigation("/")}>
                            <Typography variant="subtitle1" gutterBottom>
                                Neptune Technology
                            </Typography></Button>
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Button
                                key={page.name}
                                onClick={() => handleNavigation(page.link)}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page.name}
                            </Button>
                        ))}
                    </Box>

                    <IconButton variant="outlined" color="inherit" size="small" onClick={onWhatsApp}><WhatsAppIcon /> </IconButton>
                </Toolbar>
            </AppBar>
            <Container>
                <Outlet />
            </Container>
            {/* Footer */}
            <footer>
                <Container maxWidth="lg" align="center">
                    <Typography variant="subtitle1" paragraph>
                        Phone/WhatsApp: <a href="#" onClick={onWhatsApp}>+65 9762 9183</a> <IconButton variant="outlined" color="inherit" size="small" onClick={onWhatsApp}><WhatsAppIcon /> </IconButton>
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                        Email: operations@neptunetech.asia
                    </Typography>
                    <Typography variant="subtitle1" paragraph>
                        Address: 3 Soon Lee Street, #06-06 Pioneer Junction, Singapore 627606
                    </Typography>
                </Container>
                <Copyright />
            </footer>
            {/* End footer */}
        </ThemeProvider>
    )
};

export default DefaultLayout;